import { useState } from "react";
import { useHistory } from "react-router-dom";
import { useSnackbar } from "notistack";

import { useIoCContext } from "@context/IoCContext/IoCContext";
import { Types } from "@ioc/types";
import { ICreateUserService } from "@modules/user/models/ICreateUserService";
import { ICreateUserDTO } from "@modules/user/dtos/ICreateUserDTO";
import ROUTES from "@config/routes";

import { IFormAddUser } from "./interface";
import FormAddUserValidationSchema from "./validation";
import { createUser } from "./createUser";

export function useSubmitAddUser() {
  const { enqueueSnackbar } = useSnackbar();

  const history = useHistory();

  const [loading, setLoading] = useState(false);

  const iocContext = useIoCContext();

  const service = iocContext.serviceContainer.get<ICreateUserService>(
    Types.Users.ICreateUserService
  );

  const handleSubmit = async (values: IFormAddUser) => {
    setLoading(true);

    delete values.companyName;
    delete values.CNPJ;

    const casted = FormAddUserValidationSchema.cast(values);

    if (!casted) {
      setLoading(false);
      return;
    }

    const { data, error } = await createUser(service, casted as ICreateUserDTO);

    if (error) {
      enqueueSnackbar(error.message, { variant: error.variant });
    } else if (data?.message) {
      enqueueSnackbar(data.message, { variant: "success" });
      history.push(ROUTES.ADMIN_ROUTES.HOME);
    }

    setLoading(false);
  };

  return { loading, handleSubmit };
}
